import { createAction as toolkitCreateAction } from '@reduxjs/toolkit';

export const createAction = <T extends string>(type: T) => <P = void>() =>
  toolkitCreateAction<P, T>(type);
